import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../util/Rest';
import {ACCOUNTSUMMARY} from '../../constants/MicroServiceConstants';

const initialData = {
  columnData: [],
  columnStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'customColumns',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchColumnData: (state, action) => {
      state.columnData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      // state.successMsg = null;
    },
    postcolumnData: (state, action) => {
      state.columnStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetColumns: (state) => {
      state.columnStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
    resetSuccess: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {fetchColumnData, postcolumnData, fetchStart, resetColumns, resetSuccess, fetchError} =
  slice.actions;

export const fetchColumns = (createdBy) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${ACCOUNTSUMMARY}/find/columnname/dashboard/${createdBy}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchColumnData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postColumns = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${ACCOUNTSUMMARY}/update/columnname`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postcolumnData(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const SuccessMsg = () => {
  return (dispatch) => {
    dispatch(resetSuccess());
  };
};
export const resetColumnStatus = () => {
  return (dispatch) => {
    dispatch(resetColumns());
  };
};
